module.exports = __webpack_public_path__ + "20fd5dfeb54d93bdd4e4938b4383ab6f.svg";